import createFetchClient, { type ClientOptions, type Middleware } from 'openapi-fetch'

export interface CreateApiClientOptions extends ClientOptions {
  /** Middleware applied in order (auth, token-refresh, custom, etc.) */
  middleware?: Middleware[]
}

/**
 * Creates a typed fetch client for an OpenAPI spec.
 *
 * @example
 * ```ts
 * import type { paths } from '@mdhp/api-client/schemas/main-api'
 *
 * const client = createApiClient<paths>({
 *   baseUrl: 'https://api.example.com',
 *   middleware: [authMiddleware, tokenRefreshMiddleware],
 * })
 *
 * const { data } = await client.GET('/patients/{patient_id}', {
 *   params: { path: { patient_id: '123' } },
 * })
 * ```
 */
// eslint-disable-next-line @typescript-eslint/no-empty-object-type -- Paths must accept openapi-typescript's generated interfaces which lack a string index signature
export function createApiClient<Paths extends {}>(options: CreateApiClientOptions) {
  const { middleware = [], ...clientOptions } = options
  const client = createFetchClient<Paths>(clientOptions)

  for (const mw of middleware) {
    client.use(mw)
  }

  return client
}
